/* eslint-disable no-unused-vars */
//BackupsPage.js
/* eslint-disable react-hooks/exhaustive-deps */
/** @jsxImportSource @emotion/react */
import { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Sidebar } from "../components/Sidebar";
import { AuthContext } from "../context/AuthContext";
import { FiDownload, FiChevronUp, FiChevronDown } from "react-icons/fi";
import { GiReturnArrow } from "react-icons/gi";
import { API_BASE_URL } from "../config";

export const BackupsPage = () => {
  const [files, setFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [folder, setFolder] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [sortAsc, setSortAsc] = useState(true);
  const { token } = useContext(AuthContext);
  const [currentPrefix, setCurrentPrefix] = useState("");
  const { logout } = useContext(AuthContext);
  const [espaco, setEspaco] = useState({ used: 0, total: 10 });

  const { userBackupType } = useContext(AuthContext);
  const { permissionLevel } = useContext(AuthContext);

  const fetchEspaco = async () => {
    try {
      const res = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_storage_usage_v2`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await res.json();
      if (data.sucesso) {
        setEspaco(data);
      }
    } catch (err) {
      console.error("Erro ao obter uso de espaço:", err);
    }
  };

  const fetchFiles = async (prefix = currentPrefix) => {
    try {
      const res = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_backups_v2?mode=system&prefix=${encodeURIComponent(
          prefix,
        )}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const data = await res.json();
      if (data.arquivos) {
        setFiles(data.arquivos);
        setCurrentPrefix(prefix);
        setFolder("");
      }
    } catch (err) {
      console.error("Erro ao buscar arquivos:", err);
    }
  };

  const handleDownload = async (file) => {
    if (file.endsWith("/")) return; // Pastas não podem ser baixadas diretamente
    const res = await fetch(
      `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/download_backup?file=${encodeURIComponent(
        file,
      )}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    const data = await res.json();
    if (data.url) window.open(data.url, "_blank");
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortAsc(!sortAsc);
    } else {
      setSortBy(column);
      setSortAsc(true);
    }
  };

  const sortedFiles = [...files]
    .filter((f) => f.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      const x = a[sortBy];
      const y = b[sortBy];
      if (sortBy === "size") return sortAsc ? x - y : y - x;
      return sortAsc
        ? String(x).localeCompare(String(y))
        : String(y).localeCompare(String(x));
    });

  const formatSize = (bytes) => {
    if (bytes === 0) return "-";
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024)
      return (bytes / 1024).toFixed(1).replace(".", ",") + " KB";
    return (bytes / (1024 * 1024)).toFixed(1).replace(".", ",") + " MB";
  };

  const formatDateBR = (raw) => {
    if (!raw) return "-";
    // Se vier "YYYY-MM-DD HH:mm:ss", só troca espaço por "T".
    // Se já vier ISO (com "T" e offset), usa como está.
    const isoLike = raw.includes("T") ? raw : raw.replace(" ", "T");
    const d = new Date(isoLike); // NADA de + "Z" aqui
    if (isNaN(d)) return "-";
    return new Intl.DateTimeFormat("pt-BR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: "America/Sao_Paulo",
    }).format(d);
  };

  useEffect(() => {
    fetchFiles();
    fetchEspaco();
    document.title = "Meus Backups";
  }, []);

  const usagePct = Math.min(
    100,
    Math.max(
      0,
      espaco?.total ? (Number(espaco.used) / Number(espaco.total)) * 100 : 0,
    ),
  );

  return (
    <Wrapper>
      <Sidebar />
      <Main>
        <Content>
          {Number(userBackupType) !== 1 && (
            <CardSection>
              <SectionTitle style={{ marginTop: "unset" }}>
                Armazenamento Usado - Backup de arquivos
              </SectionTitle>
              <p style={{ marginBottom: "0.5rem" }}>
                {espaco.used} GB de {espaco.total} GB usados
              </p>
              <ProgressBarWrapper>
                <ProgressBarFill
                  $pct={usagePct}
                  style={{ width: `${usagePct}%` }}
                />
              </ProgressBarWrapper>
            </CardSection>
          )}
          {(Number(userBackupType) === 1 || Number(userBackupType) === 3) &&
            Number(permissionLevel) !== 1 && (
              <Card>
                <CardTitle>Backups do Sistema (.bcir) na Nuvem</CardTitle>

                {Array.isArray(espaco.bcirFolders) &&
                espaco.bcirFolders.length > 0 ? (
                  <div style={{ marginTop: "0.75rem" }}>
                    {espaco.bcirFolders.map((item) => (
                      <div
                        key={`${item.ID_BACKUP_DATABASE}-${item.BCK_SETTING}`}
                        style={{
                          padding: "6px 0",
                          borderBottom: "1px dashed #333",
                        }}
                      >
                        <div style={{ fontSize: 13, color: "#ccc" }}>
                          <strong>{item.BACKUP_FOLDER}</strong>
                        </div>

                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: "bold",
                            marginTop: 2,
                          }}
                        >
                          {item.bcirCount ?? 0} arquivos
                        </div>

                        <div style={{ fontSize: 12, color: "#888" }}>
                          Plano: {item.STORAGE_PLAN}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <CardValue>{espaco.bcirCount ?? 0} arquivos</CardValue>
                )}
              </Card>
            )}
          <CardSection>
            <SectionTitle>Gerenciador de Arquivos</SectionTitle>

            <SearchInput
              type="text"
              placeholder="Buscar por nome..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {currentPrefix && (
              <StyledLabelSecondary
                onClick={() =>
                  fetchFiles(currentPrefix.replace(/[^/]+\/$/, ""))
                }
                style={{ width: "max-content", margin: "15px" }}
              >
                <GiReturnArrow />
              </StyledLabelSecondary>
            )}

            <TableViewport>
              <Table>
                <thead>
                  <tr>
                    <Th onClick={() => handleSort("name")}>
                      Arquivo ou pasta{" "}
                      {sortBy === "name" &&
                        (sortAsc ? <FiChevronUp /> : <FiChevronDown />)}
                    </Th>
                    <Th onClick={() => handleSort("size")}>
                      Tamanho{" "}
                      {sortBy === "size" &&
                        (sortAsc ? <FiChevronUp /> : <FiChevronDown />)}
                    </Th>
                    <Th onClick={() => handleSort("last_modified")}>
                      Última modificação{" "}
                      {sortBy === "last_modified" &&
                        (sortAsc ? <FiChevronUp /> : <FiChevronDown />)}
                    </Th>
                    <Th>Ações</Th>
                  </tr>
                </thead>
                <tbody>
                  {sortedFiles.length === 0 ? (
                    <tr>
                      <Td colSpan="4" style={{ textAlign: "center" }}>
                        Nenhum arquivo listado ainda.
                      </Td>
                    </tr>
                  ) : (
                    sortedFiles.map((f, i) => (
                      <tr key={i}>
                        <Td>
                          {f.name.endsWith("/") ? (
                            <span
                              style={{ cursor: "pointer", color: "#4f46e5" }}
                              onClick={() => fetchFiles(f.name)}
                            >
                              📁{" "}
                              {f.name
                                .replace(currentPrefix, "")
                                .replace(/\/$/, "")}
                            </span>
                          ) : (
                            <>📄 {f.name.replace(currentPrefix, "")}</>
                          )}
                        </Td>
                        <Td>{formatSize(f.size)}</Td>
                        <Td>
                          {formatDateBR(f.last_modified_iso || f.last_modified)}
                        </Td>
                        <Td>
                          {!f.name.endsWith("/") && (
                            <IconBtn
                              onClick={() => handleDownload(f.name)}
                              title="Download"
                            >
                              <FiDownload />
                            </IconBtn>
                          )}
                        </Td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </TableViewport>
          </CardSection>
        </Content>
      </Main>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  min-height: 100dvh;
  background: #0f0f0f;
  color: #fff;
  padding-top: 60px; /* altura do header */
  padding-left: 240px; /* espaço da sidebar no desktop */
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  @media (max-width: 760px) {
    padding-left: 0; /* sem espaço fixo no mobile */
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;

  min-width: 0;
`;

const Content = styled.div`
  padding: 2rem;
`;

const TableViewport = styled.div`
  width: 100%;
  overflow-x: visible;

  @media (max-width: 1380px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  border-radius: 8px;
`;

const CardSection = styled.div`
  background: #1a1a1a;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
`;

const Card = styled.div`
  background: #1a1a1a;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  margin-bottom: 2rem;
`;

const CardTitle = styled.p`
  font-size: 0.9rem;
  color: #aaa;
`;

const CardValue = styled.p`
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 0.5rem;
`;

const SectionTitle = styled.h3`
  margin-bottom: 1.5rem;
  margin-top: unset;
  color: #e5e5e5;
`;

const StyledLabelSecondary = styled.div`
  background: #0084c2;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  &:hover {
    background: #3730a3;
  }
`;

const SearchInput = styled.input`
  background: #2a2a2a;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  width: -webkit-fill-available;
  margin-bottom: 1rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  th,
  td {
    padding: 0.75rem;
    border-bottom: 1px solid #333;
  }
  th {
    cursor: pointer;
    color: #ccc;
    text-align: left;
  }
  td {
    color: #eee;
  }
  tr:hover td {
    background-color: #222;
  }

  @media (max-width: 760px) {
    font-size: 9px;
  }
`;

const Th = styled.th``;
const Td = styled.td``;

const IconBtn = styled.button`
  background: transparent;
  color: #ccc;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  margin-right: 0.7rem;
  &:hover {
    color: white;
  }
`;

const ProgressBarWrapper = styled.div`
  background: #333;
  border-radius: 8px;
  height: 12px;
  width: 100%;
  overflow: hidden;
`;

const ProgressBarFill = styled.div`
  height: 100%;
  transition:
    width 0.5s ease,
    background 0.3s ease;
  background: ${({ $pct }) => ($pct >= 80 ? "#e74c3c" : "#3498db")};
`;

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 15, 15, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingBox = styled.div`
  background: #1a1a1a;
  color: #fff;
  padding: 1.5rem 2.5rem;
  font-size: 1.2rem;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.7);
`;
